import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';


import "./styles.scss";

const PricingPage = () => {
	const location = useLocation();

  useEffect(() => {
    if(location.hash) handleScrollToView(location.hash.slice(1))
  }, [location]);

  // ------------------ miscellaneous -------------------
  const handleScrollToView = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  };

  const prices = {
    monthly: {
      starter: 0,
      team: 29,
      business: 59,
      userAdd: 8
    },
    yearly: {
      starter: 0,
      team: 24.19,
      business: 54.19,
      userAdd: 6.67
    }
  };

  // State for active period
  const [period, setPeriod] = useState('monthly');

  // Handle period toggle
  // eslint-disable-next-line no-unused-vars
  const handlePeriodChange = (newPeriod) => {
    setPeriod(newPeriod);
  };

  return (
    <>
    <div dangerouslySetInnerHTML={{ __html: `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>LUSID Pricing | AI-Driven Payments & Accounting</title>
  <link href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;800&display=swap" rel="stylesheet">
  <style>
    :root {
      --blue-main: #0a66c2;
      --blue-dark: #004182;
      --blue-muted: #56687a;
      --blue-light: #dce6f1;
      --grey-main: #38434f;
      --grey-light: #e9e5df;
      --off-white: #fdfaf5;
      --white: #ffffff;
      --accent-green: #00c49a;
    }
    html, body {
      margin: 0;
      padding: 0;
      background: var(--white);
      color: var(--grey-main);
      font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;
      // font-size: 18px;
      line-height: 1.6;
    }
    header {
      width: 100%;
      background: var(--white);
      position: sticky;
      top: 0;
      z-index: 100;
      border-bottom: 1px solid var(--grey-light);
    }
    .nav-container {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 18px 32px;
    }
    .logo img {
      height: 40px;
      display: block;
    }
    nav {
      display: flex;
      gap: 32px;
      align-items: center;
    }
    nav a {
      text-decoration: none;
      color: var(--grey-main);
      font-weight: 500;
      font-size: 1rem;
      padding: 6px 0;
      transition: color 0.15s;
    }
    nav a:hover {
      color: var(--blue-main);
    }
    .cta-nav {
      background: var(--blue-main);
      color: var(--white);
      border-radius: 20px;
      padding: 8px 22px;
      font-weight: 600;
      font-size: 1rem;
      margin-left: 12px;
      text-decoration: none;
      transition: background 0.15s;
      border: none;
      cursor: pointer;
    }
    .cta-nav:hover {
      background: var(--blue-dark);
    }
    .hero {
      background: var(--white);
      text-align: center;
      padding: 90px 20px 60px 20px;
      margin-bottom: 40px;
    }
    .hero h1 {
      font-size: 2.8rem;
      font-weight: 800;
      color: var(--blue-main);
      margin-bottom: 18px;
      letter-spacing: -1px;
    }
    .hero p {
      font-size: 1.25rem;
      color: var(--grey-main);
      margin-bottom: 38px;
      max-width: 540px;
      margin-left: auto;
      margin-right: auto;
    }
    .hero .cta-main {
      background: var(--blue-main);
      color: var(--white);
      border-radius: 24px;
      padding: 14px 38px;
      font-size: 1.1rem;
      font-weight: 700;
      border: none;
      cursor: pointer;
      margin: 0 10px;
      transition: background 0.15s;
      box-shadow: 0 2px 16px rgba(10,102,194,0.06);
    }
    .hero .cta-main:hover {
      background: var(--blue-dark);
    }
    .section {
      max-width: 1100px;
      margin: 0 auto 60px auto;
      padding: 0 24px;
    }
    .section-title {
      font-size: 2rem;
      font-weight: 700;
      color: var(--blue-main);
      text-align: center;
      margin-bottom: 36px;
      letter-spacing: -0.5px;
    }
    /* Pricing Toggle */
    .pricing-toggle-row {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 18px;
      margin-bottom: 30px;
    }
    .pricing-toggle {
      background: var(--blue-light);
      border-radius: 16px;
      display: flex;
      overflow: hidden;
      border: 1px solid var(--blue-light);
    }
    .pricing-toggle-btn {
      padding: 10px 28px;
      background: none;
      border: none;
      color: var(--blue-main);
      font-weight: 700;
      font-size: 1em;
      cursor: pointer;
      transition: background 0.15s, color 0.15s;
    }
    .pricing-toggle-btn.active,
    .pricing-toggle-btn:hover {
      background: var(--blue-main);
      color: #fff;
    }
    /* Pricing Cards */
    .pricing-cards-row {
      display: flex;
      justify-content: center;
      gap: 32px;
      flex-wrap: nowrap;
      margin-bottom: 24px;
    }
    .pricing-card {
      background: var(--white);
      border-radius: 18px;
      box-shadow: 0 2px 16px rgba(10,102,194,0.06);
      padding: 36px 28px;
      width: 560px;
      min-width: 260px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 16px;
      border: 2px solid var(--blue-light);
      transition: border 0.2s;
    }
    .pricing-card:hover {
      border: 2px solid var(--blue-main);
    }
    .pricing-card-title {
      font-size: 1.3em;
      font-weight: 800;
      color: var(--blue-main);
      margin-bottom: 10px;
      letter-spacing: 0.5px;
    }
    .pricing-card-price {
      font-size: 2.1em;
      font-weight: 800;
      color: var(--blue-main);
      margin-bottom: 4px;
    }
    .pricing-card-period {
      color: var(--blue-muted);
      font-size: 1em;
      margin-bottom: 12px;
    }
    .pricing-card-desc {
      color: var(--grey-main);
      margin-bottom: 18px;
      font-size: 1.07em;
      text-align: center;
    }
    .pricing-card-list {
      list-style: none;
      padding: 0;
      margin: 0 0 0 0;
      text-align: left;
      width: 100%;
    }
    .pricing-card-list li {
      margin-bottom: 10px;
      padding-left: 24px;
      position: relative;
      color: var(--blue-dark);
      font-size: 1.01em;
    }
    .pricing-card-list li:before {
      content: "✔";
      color: var(--accent-green);
      position: absolute;
      left: 0;
      font-size: 1em;
      font-weight: bold;
    }
    .pricing-card-note {
      color: var(--blue-muted);
      font-size: 0.98em;
      margin: 10px 0 0 0;
      text-align: center;
    }
    /* Transaction Fees Table */
    .fees-table {
      width: 100%;
      border-collapse: collapse;
      margin: 40px auto 0 auto;
      background: var(--white);
      border-radius: 16px;
      box-shadow: 0 2px 16px rgba(10,102,194,0.06);
      overflow: hidden;
      font-size: 1em;
    }
    .fees-table th, .fees-table td {
      padding: 14px 10px;
      text-align: left;
      border-bottom: 1px solid var(--blue-light);
    }
    .fees-table th {
      background: var(--blue-light);
      color: var(--blue-main);
      font-size: 1.05em;
      font-weight: 700;
      text-align: left;
    }
    .fees-table tr:last-child td {
      border-bottom: none;
    }
    .fees-table .fees-section {
      background: var(--blue-light);
      color: var(--blue-main);
      font-weight: 700;
      font-size: 1.08em;
      text-align: left;
      border-bottom: 2px solid var(--blue-main);
    }
    .fees-table .fees-method {
      font-weight: 600;
      color: var(--blue-dark);
    }
    .fees-table .fees-note {
      color: var(--blue-muted);
      font-size: 0.98em;
      padding-top: 18px;
      border-bottom: none;
    }
    /* FAQ */
    .pricing-faq {
      max-width: 800px;
      margin: 0px auto 0px auto;
      background: var(--blue-light);
      border-radius: 14px;
      padding: 36px 28px;
      box-shadow: 0 2px 8px rgba(10,102,194,0.04);
    }
    .pricing-faq h2 {
      color: var(--blue-main);
      margin-bottom: 18px;
      font-size: 1.45em;
      font-weight: 800;
      text-align: center;
    }
    .pricing-faq-item {
      margin-bottom: 24px;
    }
    .pricing-faq-question {
      color: var(--blue-dark);
      font-weight: 700;
      margin-bottom: 6px;
      font-size: 1.08em;
    }
    .pricing-faq-answer {
      color: var(--grey-main);
      font-size: 1.01em;
      margin-bottom: 0;
    }
    .cta-section {
      background: var(--white);
      text-align: center;
      padding: 70px 0 70px 0;
    }
    .cta-section h2 {
      color: var(--blue-main);
      font-size: 2rem;
      margin-bottom: 18px;
      font-weight: 700;
    }
    .cta-section .cta-main {
      background: var(--blue-main);
      color: var(--white);
      border-radius: 24px;
      padding: 16px 46px;
      font-size: 1.1rem;
      font-weight: 700;
      border: none;
      cursor: pointer;
      margin: 0 10px;
      transition: background 0.15s;
      box-shadow: 0 2px 16px rgba(10,102,194,0.06);
    }
    .cta-section .cta-main:hover {
      background: var(--blue-dark);
    }
    footer {
      background: var(--off-white);
      padding: 40px 0;
      text-align: center;
      font-size: 1rem;
      color: var(--blue-muted);
      border-top: 1px solid var(--blue-light);
      letter-spacing: 0.1px;
    }
    @media (max-width: 1100px) {
      .pricing-cards-row { flex-wrap: wrap; }
    }
    @media (max-width: 1000px) {
      .pricing-cards-row { flex-direction: column; align-items: center; }
      .section { padding: 0 8px; }
      .fees-table th, .fees-table td { padding: 10px 6px; }
      .pricing-faq { padding: 24px 8px; }
    }
  </style>
</head>
<body>
  <section class="hero">
    <h1>Save up to 70% vs. competitors</h1>
    <p style="line-height: 2;">
      No Percentage Fees <br/>
      Unlimited Free ACH <br/>
      Lowest Instant payments <br/>
      Best Business FX conversion rates <br/>
      No Subscription Fees <br/>
      No Surprises! <br/>
    </p>
    <button class="cta-main" onclick="window.location='/contact-us'">Get Started</button>
  </section>
  ` }} />

  <section class="section" id="pricing">
    {/* <div class="section-title">Compare Plans</div> */}
    {/* <div class="pricing-toggle-row">
      <div class="pricing-toggle">
        <button id="monthlyBtn" className={`pricing-toggle-btn ${period === 'monthly' ? 'active' : ''}`} onClick={() => handlePeriodChange('monthly')}>Monthly</button>
        <button id="yearlyBtn" className={`pricing-toggle-btn ${period === 'yearly' ? 'active' : ''}`} onClick={() => handlePeriodChange('yearly')}>Yearly</button>
      </div>
    </div> */}
    <div class="pricing-cards-row">
      <div class="pricing-card">
        <div class="pricing-card-title">Unlimited Essential Features</div>
        <div class="pricing-card-price" id="starterPrice">${prices[period].starter}</div>
        <div class="pricing-card-period">per month</div>
        {/* <div class="pricing-card-note">Limited to one user.</div> */}
        <div style={{ paddingBottom: "36px" }}></div>
        {/* <div class="pricing-card-desc">Perfect for sole proprietors and small businesses just starting out.</div> */}
        <ul class="pricing-card-list">
          <li>Unlimited users</li>
          <li>Unlimited companies</li>
          <li>Unlimited free standard ACH transfers</li>
          <li>Unlimited eChecks</li>
          <li>Industry's lowest rates on Instant payments</li>
          <li>Competitive FX rates on global payments</li>
          <li>Range of payment options - eCheck, ACH, RTP/FedNow, Zelle</li>
          <li>Approval workflows & payment thresholds</li>
          <li>One time or Automatic payments with secure authorization</li>
          <li>Full integration with your existing bank account</li>
          <li>Digital wallet to suit all payment requirements</li>
          <li>Sync with your customer's and vendor's systems</li>
          <li>White-glove onboarding and ongoing support</li>
        </ul>
      </div>
      {/* <div class="pricing-card">
        <div class="pricing-card-title">Team</div>
        <div class="pricing-card-price" id="teamPrice">${prices[period].team}</div>
        <div class="pricing-card-period">per month</div>
        <div class="pricing-card-note">Includes 3 users (Additional: $8/user/month)<br/>20 free ACH transfers per month.</div>
        <div class="pricing-card-desc">Ideal for growing businesses seeking more control and efficiency.</div>
        <ul class="pricing-card-list">
          <li>Easy bill adding</li>
          <li>Efficient invoice management</li>
          <li>Global payments & collections</li>
          <li>Multiple payment delivery speeds</li>
          <li>Global payments in USD or local currencies</li>
          <li>Recurring & partial payments</li>
          <li>Batch-pay multiple bills at once</li>
          <li>Roles, permissions, and user management</li>
          <li>Advanced, custom approval workflows</li>
        </ul>
      </div>
      <div class="pricing-card">
        <div class="pricing-card-title">Business</div>
        <div class="pricing-card-price" id="businessPrice">${prices[period].business}</div>
        <div class="pricing-card-period">per month</div>
        <div class="pricing-card-note">Includes 8 users (Additional: $8/user/month)<br/>40 free ACH transfers per month.</div>
        <div class="pricing-card-desc">For established businesses needing advanced features and custom solutions.</div>
        <ul class="pricing-card-list">
          <li>Easy bill adding</li>
          <li>Efficient invoice management</li>
          <li>Global payments & collections</li>
          <li>Multiple payment delivery speeds</li>
          <li>Global payments in USD or local currencies</li>
          <li>Recurring & partial payments</li>
          <li>Batch-pay multiple bills at once</li>
          <li>Roles, permissions, and user management</li>
          <li>Advanced, custom approval workflows</li>
        </ul>
      </div> */}
    </div>
    {/* <div class="pricing-note">
      <strong>All plans include:</strong> Secure payments, unlimited invoices, bank-grade encryption, and access to all future updates.
    </div> */}

    <div class="section-title" style={{ marginTop: "60px" }}>Transaction Fees</div>
    <table class="fees-table">
      <tr>
        <th colspan="3" class="fees-section">Pay (when you pay another business)</th>
      </tr>
      <tr>
        <th>Payment method</th>
        <th>Receiving</th>
        <th>Fee</th>
        {/* <th></th> */}
      </tr>
      <tr>
        <td class="fees-method">eCheck</td>
        <td>Within seconds/minutes</td>
        <td>Free - unlimited eChecks</td>
        {/* <td></td> */}
      </tr>
      <tr>
        <td class="fees-method">Bank transfer</td>
        <td>In 2-3 business days</td>
        <td>Free - unlimited transfers</td>
        {/* <td></td> */}
      </tr>
      <tr>
        <td class="fees-method">Bank transfer</td>
        <td>Same-day</td>
        <td>$5 flat fee</td>
        {/* <td></td> */}
      </tr>
      <tr>
        <td class="fees-method">Bank transfer</td>
        <td>Within seconds/minutes (even on weekends/holidays)</td>
        <td>$10 flat fee</td>
        {/* <td></td> */}
      </tr>
      <tr>
        <td class="fees-method">Zelle transfer</td>
        <td>Within seconds/minutes</td>
        <td>$5 flat fee</td>
        {/* <td></td> */}
      </tr>
      <tr>
        <td class="fees-method">International payment from Bank account</td>
        <td>USD or Foreign currency</td>
        <td>Fair fees & low currency conversion rate applies</td>
        {/* <td></td> */}
      </tr>
      <tr>
        <th colspan="3" class="fees-section">Get paid (when another business pays you with Lusid)</th>
      </tr>
      <tr>
        <th>Payment method</th>
        <th>Receiving</th>
        <th>Fee (you decide who pays this fee)</th>
        {/* <th></th> */}
      </tr>
      <tr>
        <td class="fees-method">eCheck</td>
        <td>Within seconds/minutes</td>
        <td>Free - unlimited eChecks</td>
        {/* <td></td> */}
      </tr>
      <tr>
        <td class="fees-method">Bank transfer</td>
        <td>In 2-3 business days</td>
        <td>Free - unlimited transfers</td>
        {/* <td></td> */}
      </tr>
      <tr>
        <td class="fees-method">Bank transfer</td>
        <td>Same-day</td>
        <td>$5 flat fee</td>
        {/* <td></td> */}
      </tr>
      <tr>
        <td class="fees-method">Bank transfer</td>
        <td>Within seconds/minutes (even on weekends/holidays)</td>
        <td>$10 flat fee</td>
        {/* <td></td> */}
      </tr>
      <tr>
        <td class="fees-method">Zelle transfer</td>
        <td>Within seconds/minutes</td>
        <td>$5 flat fee</td>
        {/* <td></td> */}
      </tr>
      <tr>
        <td class="fees-method">International collection to Bank account</td>
        <td>USD or Foreign currency</td>
        <td>Fair fees & low currency conversion rate applies</td>
        {/* <td></td> */}
      </tr>
      <tr>
        <td colspan="3" class="fees-note">
          Additional fees may apply in exception conditions like failed, cancelled, or returned transactions.
        </td>
      </tr>
    </table>
  </section>

<div dangerouslySetInnerHTML={{ __html: `



  <section class="pricing-faq" style="padding: 20px; max-width: 500px;">

    <div  
      style="display: flex; align-items: center; justify-content: space-between; gap: 10px;">
      <h2 style="font-size: 20px;">
        Optional - Accounting Integration 
      </h2>
      <span style="color: white; background: #0a66c2; padding: 5px; border-radius: 10px; font-size: 18px; font-weight: 800; margin-bottom: 18px;">$10/month</span>
    </div>

    Fully sync-up with QuickBooks Desktop/Online, Zoho Books & Xero <br/>
    Bi-directional integration included <br/>
    Full support in data mapping and setting up <br/>
  </section>  

  <section class="cta-section" id="contact">
    <button class="cta-main" onclick="window.location='/contact-us'">Get Started</button>
  </section>

  <section class="pricing-faq" id="pricing-faq" style="margin-bottom: 80px;">
    <h2>Frequently Asked Questions</h2>
    <div class="pricing-faq-item">
      <div class="pricing-faq-question">Which payment methods can I use with Lusid for domestic payments?</div>
      <div class="pricing-faq-answer">Lusid supports all modern payment options like Instant, Same-Day ACH, and Zelle. Apart from these, Lusid also offers completely free unlimited Standard ACH, and eChecks.</div>
    </div>
    <div class="pricing-faq-item">
      <div class="pricing-faq-question">Are there any setup or customization fees?</div>
      <div class="pricing-faq-answer">We believe in no setup or customization fees. For rare complex integrations or enterprise level requirements, a one-time fee may apply (discussed upfront).</div>
    </div>
    <div class="pricing-faq-item">
      <div class="pricing-faq-question">Do you charge for international payments?</div>
      <div class="pricing-faq-answer">Lusid offers competitive FX rates and transparent fees. All rates and fees are disclosed before you send a payment.</div>
    </div>
    <div class="pricing-faq-item">
      <div class="pricing-faq-question">Can I cancel my plan?</div>
      <div class="pricing-faq-answer">Yes, you can cancel your plan at any time. Contact our team for assistance.</div>
    </div>
    <div class="pricing-faq-item">
      <div class="pricing-faq-question">What are the Instant Payment options offered by Lusid?</div>
      <div class="pricing-faq-answer">We provide multiple Instant payment solutions, like Federal Reserve’s FedNow, The Clearing House’s RTP, and Zelle, to transfer money in seconds between banks, any time during or outside of bank hours.</div>
    </div>
    <div class="pricing-faq-item">
      <div class="pricing-faq-question">What does my customer have to do to send me payments?</div>
      <div class="pricing-faq-answer">When you send a payment request, your customer can authorize the request to complete the payment. Alternatively, they can also use Lusid platform to pay as a guest by securely connecting their bank account or create a Lusid account to choose how they send the funds.</div>
    </div>
    <div class="pricing-faq-item">
      <div class="pricing-faq-question">Who pays for the modern, faster payment options processed by customer?</div>
      <div class="pricing-faq-answer">When customer pays your business, the transaction fees for faster payments are paid by customers by default. But each business can configure the setting to pay this fees themselves.</div>
    </div>
  </section>

</body>
<script>
    document.addEventListener('DOMContentLoaded', function() {
      const monthlyBtn = document.getElementById('monthlyBtn');
      const yearlyBtn = document.getElementById('yearlyBtn');
      
      const prices = {
        monthly: {
          starter: 0,
          team: 29,
          business: 59,
          userAdd: 8
        },
        yearly: {
          starter: 0,
          team: 24.19,
          business: 54.19,
          userAdd: 6.67
        }
      };

      function updatePrices(period) {
        // Get price elements
        const starterPrice = document.getElementById('starterPrice');
        const teamPrice = document.getElementById('teamPrice');
        const businessPrice = document.getElementById('businessPrice');
        const teamNote = document.getElementById('teamNote');
        const businessNote = document.getElementById('businessNote');

        // Update prices safely with error checking
        if (starterPrice) starterPrice.textContent = \`$\${prices[period].starter}\`;
        if (teamPrice) teamPrice.textContent = \`$\${prices[period].team}\`;
        if (businessPrice) businessPrice.textContent = \`$\${prices[period].business}\`;

        // Update notes with user add-on prices
        const addOnPrice = prices[period].userAdd;
        if (teamNote) {
          teamNote.innerHTML = \`Includes 3 users (Additional: $\${addOnPrice}/user/\${period})<br>20 free ACH transfers per month.\`;
        }
        if (businessNote) {
          businessNote.innerHTML = \`Includes 8 users (Additional: $\${addOnPrice}/user/\${period})<br>40 free ACH transfers per month.\`;
        }

        // Update period text for all cards
        document.querySelectorAll('.pricing-card-period').forEach(el => {
          el.textContent = \`per \${period}\`;
        });
      }

      // Event listeners for toggle buttons
      if (monthlyBtn) {
        monthlyBtn.addEventListener('click', () => {
          monthlyBtn.classList.add('active');
          yearlyBtn.classList.remove('active');
          updatePrices('monthly');
        });
      }

      if (yearlyBtn) {
        yearlyBtn.addEventListener('click', () => {
          yearlyBtn.classList.add('active');
          monthlyBtn.classList.remove('active');
          updatePrices('yearly');
        });
      }
    });
</script>
</html>
` }} />
</>
  )
}

export default PricingPage;

